import { Link } from "react-router-dom";
import { Rocket, Check } from "lucide-react";

import { _t } from "@/lib/i18n";
function Nav() {
  return (
    <header className="glass-header sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <Rocket className="w-5 h-5 text-[#FF5722] -rotate-45" />
          <div className="font-display text-2xl text-white">{_t("Time Capsule")}</div>
        </Link>
        <nav className="hidden md:flex items-center gap-2 text-sm">
          <Link to="/come-funziona" className="px-3 py-2 text-white/70 hover:text-white">{_t("Come funziona")}</Link>
          <Link to="/prezzi" className="px-3 py-2 text-[#FF5722]">{_t("Prezzi")}</Link>
          <Link to="/sicurezza" className="px-3 py-2 text-white/70 hover:text-white">{_t("Sicurezza")}</Link>
          <Link to="/faq" className="px-3 py-2 text-white/70 hover:text-white">{_t("FAQ")}</Link>
        </nav>
        <div className="flex gap-3"><Link to="/login" className="btn-ghost">{_t("Accedi")}</Link><Link to="/register" className="btn-launch">{_t("Inizia")}</Link></div>
      </div>
    </header>
  );
}

const PLANS = [
  { id: "free", name: "Free", price: "€0", period: _t("per sempre"), desc: _t("Per iniziare, senza fretta."),
    features: [_t("1 capsula attiva"), _t("200 MB di archivio"), _t("Fino a 3 destinatari"), _t("Testo, foto, link"), _t("Apertura entro 5 anni")],
    cta: _t("Inizia gratis"), highlight: false },
  { id: "plus", name: "Plus", price: "€4,90", period: _t("al mese"), desc: _t("Per chi vive di ricordi."),
    features: [_t("Capsule illimitate"), _t("10 GB di archivio"), _t("Destinatari illimitati"), _t("Audio e video"), _t("Apertura fino a 30 anni"), _t("Notifiche email")],
    cta: _t("Prova 14 giorni"), highlight: true },
  { id: "family", name: "Family", price: "€9,90", period: _t("al mese"), desc: _t("Fino a 6 persone."),
    features: [_t("Tutto di Plus"), _t("6 membri"), _t("Contatti fiduciari"), _t("Assistenza prioritaria"), _t("Backup avanzato")],
    cta: _t("Scegli Family"), highlight: false },
  { id: "legacy", name: "Legacy", price: _t("Su richiesta"), period: _t("conservazione lunga"), desc: _t("Per generazioni."),
    features: [_t("Conservazione garantita"), _t("Verifiche periodiche"), _t("Contatto fiduciario multiplo"), _t("Assistenza dedicata"), _t("Audit indipendenti")],
    cta: _t("Contattaci"), highlight: false },
];

export default function Pricing() {
  return (
    <div className="min-h-screen">
      <Nav />
      <section className="max-w-6xl mx-auto px-6 py-24">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#FF5722] mb-4">{_t("Prezzi")}</div>
        <h1 className="font-display text-6xl md:text-7xl text-white leading-tight mb-4">{_t("Custodi del tempo, a modo tuo.")}</h1>
        <p className="text-lg text-white/60 max-w-2xl mb-12">{_t("Un piano gratuito per iniziare. Piani più ricchi per chi vuole custodire di più, più a lungo. Nessuna pubblicità, mai.")}</p>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {PLANS.map((p) => (
            <div key={p.id} data-testid={`plan-${p.id}`} className={`tc-card p-6 flex flex-col ${p.highlight ? "border-[#FF5722]/50 !bg-[#FF5722]/5" : ""}`}>
              {p.highlight && <div className="text-[10px] uppercase tracking-[0.3em] text-[#FF5722] mb-2">{_t("Consigliato")}</div>}
              <div className="font-display text-3xl text-white">{p.name}</div>
              <div className="text-sm text-white/60 mb-4">{p.desc}</div>
              <div className="mb-6">
                <div className="text-4xl font-display text-white">{p.price}</div>
                <div className="text-xs text-white/50">{p.period}</div>
              </div>
              <ul className="space-y-2 text-sm text-white/80 mb-6 grow">
                {p.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-2"><Check className="w-4 h-4 text-[#FF5722] mt-0.5 shrink-0" /> {f}</li>
                ))}
              </ul>
              <Link to="/register" className={p.highlight ? "btn-launch text-center" : "btn-ghost text-center"}>{p.cta}</Link>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center text-xs text-white/40">{_t("Nessuna pubblicità nella tua area privata. Tutti i piani includono cifratura e diritto all'esportazione.")}</div>
      </section>
    </div>
  );
}
